import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetUserLevel } from "./service";

export const useGetLevelList = ({ options }) => {
  return useQuery(
    [queryKey.VIP_USER_LEVEL],
    () => apiGetUserLevel({}).then((res) => res.data.data),
    {
      ...options,
    },
  );
};
